define('views/search/results',[
  "globals",
  "backbone",
  "URIjs",
  "templates"
], function (globals, Backbone, URI, JST) {
  "use strict";

  return Backbone.View.extend({
    events: {
      "click button": "getMoreResults"
    },

    initialize: function (options) {
      this.options = options;
      _.bindAll(this, "render");
      this.listenTo(this.model, "resetDefaults", this.reset);
    },

    toggleLoadingIndicator: function () {
      var $spinner = this.$(".fa-spinner");

      this.$el.toggleClass("loading");

      if ($spinner.length) {
        $spinner.remove();
      } else {
        this.$el.append($("<i/>", {
          "class": "fa fa-spinner fa-spin"
        }));
      }

      return this;
    },

    getMoreResults: function () {
      this.$(".more-results").remove();
      this.model.increaseOffset();
      return this;
    },

    scrollTo: function (to, duration) {
      this.$el.animate({ scrollTop: to }, duration);
      return this;
    },

    render: function (response) {
      var hits = response.get("hits"),
         total = response.get("total"),
     highlight = response.get("highlight"),
      keywords = response.get("keywords"),
          more = this.model.onlyOffsetChanged();

      this.toggleLoadingIndicator();

      if (total) this.model.set("total", total);

      // If only the offset has changed, that means the user has requested for
      // more results for the current search term instead of making a new
      // search. Therefore, we only empty the search results element if
      // something *else* besides offset has changed.
      if (!more) this.reset().scrollTo(0, 150);

      if (!hits.length) {
        this.$el.append($("<li/>", { text: Messages("search.no_results") }));

        return false;
      }

      return this.showTotalResults(total)
                 .appendHits(hits, keywords, more)
                 .fadeInNewHits(hits, 250)
                 .hijackLinks(highlight)
                 .toggleMoreResultsButton();
    },

    showTotalResults: function (total) {
      // If the offset of the current search is the default offset, that means
      // this is a new search, which means we want to show the total number
      // of hits. If the offset is something else, the user has requested for
      // more results rather than a new search, so we won't prepend the total
      // number of hits because it's already there.
      if (this.model.get("offset") === this.model.defaults.offset) {
        this.$el.prepend($("<li/>", {
          "class": "result-amount",
          text: total + " " + (total === 1 ? Messages("search.result") : Messages("search.results"))
        }));
      }

      return this;
    },

    getHitURI: function (hit, keywords) {
      var base = $("main").data("content-base");

      return new URI({
        path: URI.joinPaths(base, hit.library, hit.version, hit.language, hit.path).path(),
        query: window.encodeURIComponent(keywords),
        fragment: hit.fragment
      });
    },

    getResultIconClass: function (hit) {
      if (hit.type === "Annotation" || hit.type === "Comment") {
        return "fa fa-comment-o";
      } else {
        return "fa fa-book";
      }
    },

    appendHits: function (hits, keywords, more) {
      _.each(hits, function (hit, i) {
        var classes = [hit.type];

        if (more && i === 0) classes.push("more");

        hit.uri = this.getHitURI(hit, keywords).toString();

        this.$el.append(JST["app/assets/templates/search/results.html"]({
          singleLibraryMode: globals.options.singleLibrary,
          className: classes.join(" "),
          icon: this.getResultIconClass(hit),
          hit: hit
        }));
      }, this);

      return this;
    },

    fadeInNewHits: function (hits, duration) {
      var $newHits = this.$("li").slice(-hits.length, -1);
      $newHits.css({ opacity: 0 }).animate({ opacity: 1 }, duration);
      return this;
    },

    hijackLinks: function (highlight) {
      this.$(".link a").on("click", function (e) {
        globals.content.set("highlight", highlight);
        globals.content.set("location", {
          library: $(this).data("library"),
          version: $(this).data("version"),
          language: $(this).data("language"),
          path: $(this).data("path")
        });

        e.preventDefault();

        if(window.innerWidth < 768 &&  $("#navpane").hasClass("in") === true) {
          $("#collapseTOC").trigger("click");
        }

      });

      return this;
    },

    reset: function () {
      this.$el.empty();
      return this;
    },

    toggleMoreResultsButton: function () {
      var total = this.model.get("total"), max = this.model.get("maxResults");

      if (total - max >= 1) {
        this.$el.append(JST["app/assets/templates/search/more.html"]());
        this.model.decreaseTotal();
      } else {
        this.$(".more-results").remove();
      }

      return this;
    }
  });
});

